import React, { useContext } from "react";
import { RicosContext } from "./../../ricos-context/index.js";
import { withEditorEvents } from "./../../editor-common/EditorEventsContext.js";
import { PollContextProvider } from "../components/poll-context/PollContext.js";
import { RCEHelpersContext } from "../components/rce-helpers-context/index.js";
import { Poll } from "./poll-component.js";
const Polls = (props) => {
  const { theme, t, isMobile } = useContext(RicosContext);
  const setPoll = (poll) => {
    const { updateAttributes } = props;
    updateAttributes?.({ poll });
  };
  const { componentData, helpers, editorEvents, selected, isViewMode = false, settings } = props;
  return /* @__PURE__ */ React.createElement(
    RCEHelpersContext.Provider,
    {
      value: {
        isViewMode: isViewMode ? isViewMode : settings.isWebView || typeof selected === "boolean" ? !selected : true,
        setInPluginEditingMode: () => {
        },
        layout: componentData.layout,
        design: componentData.design,
        preventVoting: !isViewMode,
        isPreview: isMobile,
        helpers,
        theme,
        t,
        isMobile,
        ...settings
      }
    },
    /* @__PURE__ */ React.createElement(
      PollContextProvider,
      {
        editorEvents,
        settings,
        poll: componentData.poll,
        setPoll,
        t
      },
      /* @__PURE__ */ React.createElement(Poll, null)
    )
  );
};
var poll_viewer_default = withEditorEvents(Polls);
export {
  poll_viewer_default as default
};
//# sourceMappingURL=poll-viewer.js.map
